import { useEffect, useMemo, useState } from "react";

import { systemConstants } from "@shared/constants";
import {
  useAuthUser,
  useFeatures,
  useLazyGetProjectsForDashboardQuery
} from "@shared/hooks";

import { routeConstants } from "@app/constants";

export function useDefaultLandingPageLink() {
  const { isSuccess: isFeaturesLoaded, isEnabled } = useFeatures();
  const { user } = useAuthUser();
  const [isLoaded, setIsLoaded] = useState(false);

  const [defaultLandingPageLink, setDefaultLandingPageLink] = useState("");
  const [fetchProjectsForDashboardQuery] =
    useLazyGetProjectsForDashboardQuery();

  const isRedirectClientUsersEnabled = useMemo(() => {
    return isEnabled(
      systemConstants.features.redirectClientUsersToProjectDashboard
    );
  }, [isEnabled]);

  useEffect(() => {
    if (!isFeaturesLoaded) {
      return;
    }
    if (user?.isClientUser && isRedirectClientUsersEnabled) {
      fetchProjectsForDashboardQuery({ myProjects: true, pageId: 1 }, true)
        .unwrap()
        .then(projects => {
          if (projects.length === 1) {
            setDefaultLandingPageLink(
              `${routeConstants.projects}/${projects[0].id}`
            );
          } else {
            setDefaultLandingPageLink(routeConstants.clientDashboard);
          }
        })
        .catch(() => {
          setDefaultLandingPageLink(routeConstants.clientDashboard);
        });
    } else {
      setDefaultLandingPageLink(routeConstants.clientDashboard);
    }
  }, [
    isFeaturesLoaded,
    isRedirectClientUsersEnabled,
    fetchProjectsForDashboardQuery,
    user
  ]);

  useEffect(() => {
    if (defaultLandingPageLink) {
      setIsLoaded(true);
    }
  }, [defaultLandingPageLink]);

  return {
    defaultLandingPageLink,
    isLoadedPageLink: isLoaded,
    type:
      defaultLandingPageLink === routeConstants.clientDashboard
        ? "client"
        : "project"
  };
}
